import { io } from 'socket.io-client';
import configJson from '../../../../../../sites/common_site_config.json';

export function initSocket() {
  const host = window.location.hostname;
  const isNumericIP = /^[0-9.]+$/.test(host);
  let url: any;
  if (isNumericIP) {
    console.log(isNumericIP, 'number');
    // url = window.origin;
    const port = window.location.port ? `:${configJson.socketio_port}` : '';
    const protocol = port ? 'http' : 'https';
    url = `${protocol}://${host}${port}`;
    console.log(url, 'url ip');
  }
  const socket = io(url, {
    transports: ['websocket'],
    withCredentials: true,
    reconnectionAttempts: 5,
  });

  return socket;
}
